import { Component } from '@angular/core';
import { LacertaDynamicTypeComponent } from '@lacerta/cms';

@Component({
  template: ` <setis-text-brackets> <lacerta-rich-text-block [content]="context"></lacerta-rich-text-block> </setis-text-brackets> `,
})
export class SetisWagtailQuoteComponent extends LacertaDynamicTypeComponent<string> {}
